import {CameraHandler} from "features/apartmentViewer/ApartmentViewer/services/CameraHandler";
import {EventManager} from "features/apartmentViewer/ApartmentViewer/services/EventManager";
import {PanoramaManager} from "features/apartmentViewer/ApartmentViewer/services/PanoramaManager";
import {PostProcessingRenderer} from "features/apartmentViewer/ApartmentViewer/renderers/PostProcessingRenderer";
import {UserNavigationContainer} from "features/apartmentViewer/ApartmentViewer/containers/UserNavigationContainer";
import {LayerContainer} from "features/apartmentViewer/ApartmentViewer/containers/LayerContainer";
import {TimeService} from "features/apartmentViewer/ApartmentViewer/services/TimeService";

export class ApartmentViewer  {

    private animationId: number = 0;

    constructor(
        private panoramaManager: PanoramaManager,
        private timeService: TimeService,
        private eventManager: EventManager,
        private cameraHandler: CameraHandler,
        private postProcessingRenderer: PostProcessingRenderer,
        private userNavigationContainer: UserNavigationContainer,
        private baseLayerContainer: LayerContainer,
        private userNavigationLayerContainer: LayerContainer,
    ) {}

    render = () => {
        this.animationId = requestAnimationFrame(this.render);
        this.timeService.update();
        this.updateServices();
        this.renderScene();
        this.finalizeFrame();
    };

    private updateServices() {
        this.eventManager.update();
        this.cameraHandler.update();
        this.panoramaManager.update();
        this.panoramaManager.handleMarkerIfNotInTransition();
        this.userNavigationContainer.update();
    }

    private renderScene() {
        this.postProcessingRenderer.render(this.baseLayerContainer, this.userNavigationLayerContainer);
    }

    private finalizeFrame() {
        this.eventManager.endFrame();
    }


    private stopRendering() {
        cancelAnimationFrame(this.animationId);
    }

    dispose() {
        this.stopRendering();
    }
}
